import OapPopup from './code/Scripts/components/OapPopup.vue';

export default {
  components: {
    OapPopup,
  },
};
